import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageLoader } from '@/components/common/PageLoader';

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

const CorporateActionReportPage = lazy(() => import('@/pages/reports/CorporateActionReportPage'));
const ExerciseExpiryReportPage = lazy(() => import('@/pages/reports/ExerciseExpiryReportPage'));
const TerminationReportPage = lazy(() => import('@/pages/reports/TerminationReportPage'));
const RealizedPnLReportPage = lazy(() => import('@/pages/reports/RealizedPnLReportPage'));
const FixResetReportPage = lazy(() => import('@/pages/reports/FixResetReportPage'));
const FeesReportPage = lazy(() => import('@/pages/reports/FeesReportPage'));
const MaturityEventsReportPage = lazy(() => import('@/pages/reports/MaturityEventsReportPage'));
const PnLReportsPage = lazy(() => import('@/pages/reports/PnLReportsPage'));
const MessageReportPage = lazy(() => import('@/pages/reports/MessageReportPage'));

export default function ReportRoutes() {
  return (
    <>
      <Route path="/reports/messages" element={<ProtectedRoute><MainLayout><LazyPage><MessageReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/corporate-actions" element={<ProtectedRoute><MainLayout><LazyPage><CorporateActionReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/exercises-expiries" element={<ProtectedRoute><MainLayout><LazyPage><ExerciseExpiryReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/terminations" element={<ProtectedRoute><MainLayout><LazyPage><TerminationReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/realized-pnl" element={<ProtectedRoute><MainLayout><LazyPage><RealizedPnLReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/fix-reset" element={<ProtectedRoute><MainLayout><LazyPage><FixResetReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/fees" element={<ProtectedRoute><MainLayout><LazyPage><FeesReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/maturity-events" element={<ProtectedRoute><MainLayout><LazyPage><MaturityEventsReportPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/reports/pnl" element={<ProtectedRoute><MainLayout><LazyPage><PnLReportsPage /></LazyPage></MainLayout></ProtectedRoute>} />
    </>
  );
}
